export const environment = {
  appTitle:'Goawake | Creare Sistemas',
  isGoawake:true,
  companyId: 'safety',
  companyName:'Safety',
  creareName:'Creare Sistemas',
  userNameCreare:'Creare',
  urlCreareWebsite: 'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grkocmhf7oyf/b/GoAwakePublicObjects/o/manual-creare-safety.pdf',
  logo:'assets/images/logo_creare.png',
  urlApi:'https://api-qa.goawakecloud.com.br/api/',
  urlCommandsApi:'https://api-qa.goawakecloud.com.br/commands',
  urlFocusRedis: 'http://focusredis.crearesistemas.com.br',
  orFrotalog:'ou no Frotalog',
  domain:'goawakecloud.com.br',
  defaultUserImg:'assets/images/creare.png',
  notFoundImg:'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grkocmhf7oyf/b/GoAwakePublicObjects/o/image-not-found.png',
  jsonLink: 'https://objectstorage.sa-saopaulo-1.oraclecloud.com/n/grkocmhf7oyf/b/GoAwakePublicObjects/o/ABRANGENCIA_PERIMETRO_SVAA_16-06-2020.geojson',
  recaptchaSitekey:'6LcDFKcaAAAAAEccDbfhLLGNqJpPzfiYcv_I3CV-',
  production:false,
  nodeEnv: 'production',
  urlTelemetry: 'https://api-qa.goawakecloud.com.br/telemetry',
  urlEvents: 'https://api-qa.goawakecloud.com.br/events',
  alarmTypesRequiredFatigueMedias:'1,2,3,4,5,6,7,8,9,15,32,45,162',
  emailEvents: 'spotx@goawake.com',
  loginRoute: 'goawake',
  loginUrl: 'https://login-qa.goawakecloud.com.br/',
  allowedAccessList: '444,2154,881,34,1065,1570,1609,2181,614,2281,2169',
  satelliteMapApi: 'https://tiles.mapquest.com/render/latest/satellite/{z}/{x}/{y}/256/png',
  defaultMapApi: 'https://osm.crearecloud.com.br/tiles/{z}/{x}/{y}.png',
  baseUrl: 'https://qa.goawakecloud.com.br',
  idleTimeOutMinutes: 30,
  idleSkipPaths: [""],
  userTypeTreatment: ["(Conclusion)"],
  fenceApiUrl: 'undefined',
  urlCoreApi: 'https://api-qa.crearecloud.com.br/core/',
  urlCoreFront: 'https://qa.crearecloud.com.br/core/',
  customTemplateEmailCustomerIds: ["202"],
  equipmentsTypeIdWithoutMedia: '5' ,
  ambiparDealerId: '4',
  hideLayout: false,
  ignorePasswordReset: false,
  operationMapUrl: 'undefined',
  vecchCodelcoApiUrl: 'undefined',
  gobusProgVsRealBff: 'undefined',
  urlBusRoute: 'undefined',
  googleMapsKey: 'undefined',
  coreTripsFrontendUrl: 'undefined',
  customersWithCustomTranslation: '47,102,251',
  streamingExpirationTime: '60000',
  playbackIntervalHours: 6,
  playbackDownloadsLimitInMonths: 3,
  osmBaseUrl: 'https://nominatim.crearecloud.com.br/',
};
